<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="50" transition="scale-transition" offset-y min-width="290">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="localValue"
        :prepend-icon="eventIcon"
        hide-details="auto"
        readonly
        clearable
        dense
        :disabled="!isActive"
        class="pa-2"
        :clear-icon="closeIcon"
        :error-messages="errors"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="localValue" :max="max" :min="min" :first-day-of-week="1" color="purple"></v-date-picker>
  </v-menu>
</template>

<script>
import { mdiCalendarBlank, mdiClose } from '@mdi/js'

export default {
  name: 'dateFilter',
  props: {
    value: String,
    type: String,
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: true
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.sendData(value)
      }
    }
  },
  data: () => ({
    menu: false,
    eventIcon: mdiCalendarBlank,
    closeIcon: mdiClose
  }),
  methods: {
    sendData (value) {
      this.$emit('date-filter-changed', { value, type: this.type })
      this.menu = false
    }
  }
}
</script>

<style scoped>

</style>
